module.exports = __webpack_public_path__ + "static/media/favorites-menu.5dca7ab0.svg";